function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    x: "0px",
    y: "0px",
    style: {
      maxWidth: "100%"
    },
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {},
    fill: "#fff",
    id: titleId
  }, "Manager_3") : title ? /*#__PURE__*/React.createElement("title", {
    style: {},
    fill: "#fff",
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M62,23H56.69l-.46-.89,4.22-4.31a2,2,0,0,0,0-2.8L49.84,4.16a2,2,0,0,0-2.86,0L42,9.25V2a2,2,0,0,0-2-2H25a2,2,0,0,0-2,2V9.64L17.8,4.55a2,2,0,0,0-2.8,0L4.16,15.16a2,2,0,0,0,0,2.86l4.27,4.17c-.15.27-.3.54-.43.81H2a2,2,0,0,0-2,2V40a2,2,0,0,0,2,2H5.92c.22.8.47,1.6.76,2.38L4.07,47a2,2,0,0,0,0,2.82L14.68,60.43a1.35,1.35,0,0,0,.32.26V62a2,2,0,0,0,4,0V43.06A5.07,5.07,0,0,1,24.06,38h2a6,6,0,0,0,3.52,4.5L24.16,55.21a2,2,0,0,0,.43,2.2l6,6a2,2,0,0,0,2.82,0l6-6a2,2,0,0,0,.43-2.2L34.39,42.5A6,6,0,0,0,37.91,38h2A5.07,5.07,0,0,1,45,43.06V62a2,2,0,0,0,4,0V60.69a1.35,1.35,0,0,0,.32-.26L59.93,49.82a2,2,0,0,0,0-2.82l-2.61-2.62c.29-.78.54-1.58.76-2.38H62a2,2,0,0,0,2-2V25A2,2,0,0,0,62,23ZM32,59.17l-3.63-3.63L32,47.08l3.63,8.46ZM32,39a2,2,0,0,1-1.72-1h3.44A2,2,0,0,1,32,39Zm28-1H56.5a2,2,0,0,0-2,1.6,22.6,22.6,0,0,1-1.41,4.48,2,2,0,0,0,.43,2.2l2.13,2.13L49,55.1v-12A9.08,9.08,0,0,0,39.94,34H24.06A9.08,9.08,0,0,0,15,43.06v12L8.31,48.41l2.13-2.13a2,2,0,0,0,.43-2.2A22.6,22.6,0,0,1,9.46,39.6a2,2,0,0,0-2-1.6H4V27H9.25a2,2,0,0,0,1.83-1.18,23.72,23.72,0,0,1,1.56-2.89,2,2,0,0,0-.29-2.49L8.42,16.59l8-7.81,4.78,4.68a2,2,0,0,0,2.18.41c.74-.31,1.49-.58,2.23-.81A2,2,0,0,0,27,11.15V4H38v6.84a2,2,0,0,0,1.39,1.9c.71.23,1.44.51,2.17.83a2,2,0,0,0,2.23-.43l4.62-4.72,7.81,8-3.91,4A2,2,0,0,0,52,22.83a24.05,24.05,0,0,1,1.54,3A2,2,0,0,0,55.41,27H60ZM32,14a9,9,0,1,0,9,9A9,9,0,0,0,32,14Zm0,14a5,5,0,1,1,5-5A5,5,0,0,1,32,28Z",
    style: {},
    fill: "#fff"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvvg2);
export default __webpack_public_path__ + "static/media/svvg2.0b9b703fc963691145ba16515b9641d1.svg";
export { ForwardRef as ReactComponent };